import logo from "../assets/GivAuraWhite.svg";

export default function Logo({
  className = "p-2 pt-3",
  height = "h-24",
  onClick,
}) {
  return (
    <div
      onClick={onClick}
      className={`flex items-center cursor-pointer ${className}`}
    >
      <img
        src={logo}
        alt="GivAura logo"
        className={`${height} w-auto object-contain -my-6`}
      />
    </div>
  );
}